import { FileTypeEnum } from "api/actor";
import { PlateformeDto } from "api/plateforme";
import { ImageUpload } from "components/forms/ImageUpload";
import { FC, useCallback, useState } from "react";
import { plateformesAPI } from "services/swagger-api";

interface LogosSectionProps {
  plateforme: PlateformeDto
  refresh: () => void
}

export const LogosSection: FC<LogosSectionProps> = ({
  plateforme,
  refresh
}) => {
  const [mainLogoError, setMainLogoError] = useState<string | null>(null);
  const [miniLogoError, setMiniLogoError] = useState<string | null>(null);

  const onLogoChange = useCallback(async (logo: File | null, fileType: FileTypeEnum) => {
    if (logo) {

      const response = await plateformesAPI.uploadPlateformeLogo({
        plateformeId: plateforme.id,
        fileType,
        file: logo
      });

      if (response.isSuccess) {
        refresh()
      }
    }
  }, [plateforme.id, refresh])

  const onRemoveLogo = useCallback(async (logo: File | null, fileType: FileTypeEnum) => {
    if (logo)
      await plateformesAPI.uploadPlateformeLogo({
        plateformeId: plateforme.id,
        fileType,
        file: logo
      });
  }, [plateforme.id])


  return (
    <div className="space-y-6 w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Logo Principal */}
        <div className="space-y-2">
          <ImageUpload
            onChange={(logo) => onLogoChange(logo, FileTypeEnum.LogoPlateforme)}
            onError={setMainLogoError}
            label="Logo Principal"
            placeholder="Ajouter le logo principal"
            dragPlaceholder="Glissez-déposez le logo principal"
            height="h-36"
            maxSizeInMB={5}
            showPreview={true}
            allowRemove={true}
            allowChange={true}
            previewUrl={plateforme.theme?.logoUrl}
          />
        </div>
        <div className="space-y-2">
          <ImageUpload
            onChange={(logo) => onLogoChange(logo, FileTypeEnum.LogoMinimalPlateforme)}
            onError={setMiniLogoError}
            label="Logo Miniature"
            placeholder="Ajouter le logo miniature"
            dragPlaceholder="Glissez-déposez le logo miniature"
            height="h-36"
            maxSizeInMB={2}
            showPreview={true}
            allowRemove={true}
            allowChange={true}
            previewUrl={plateforme.theme?.minimalLogoUrl}
          />
        </div>
      </div>
    </div>
  );
};
